import { CultureInfo } from '../culture-info.model';
import { CultureInfoZhHans } from './zh-Hans';

/**
 * @ignore
 */
export const CultureInfoZhHansCN: CultureInfo = {
  name: 'zh-Hans-CN',
  displayName: '简体中文（中国大陆）',
  iso3LanguageCode: 'zho',
  iso2LanguageCode: 'zh',
  ietfLanguageTag: 'zh-Hans-CN',
  parent: CultureInfoZhHans
};
